var _path, _path2, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMedia = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 56"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EF5D54",
  fillRule: "evenodd",
  d: "M7.883 18.62A2.47 2.47 0 0 0 6.63 21.88l4.9 11.004v-15.89zm15.923-7.09h11.5l-.898-2.016a2.47 2.47 0 0 0-3.262-1.252zm18.606 15.962v14.406l3.096-1.379a2.47 2.47 0 0 0 1.252-3.261zM29.234 47.765h-11.08l.829 1.86a2.47 2.47 0 0 0 3.261 1.252z",
  clipRule: "evenodd",
  opacity: 0.3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EF5D54",
  d: "M13.177 16.06a2.47 2.47 0 0 1 2.47-2.471h22.235a2.47 2.47 0 0 1 2.471 2.47v27.177a2.47 2.47 0 0 1-2.47 2.47H15.646a2.47 2.47 0 0 1-2.47-2.47z",
  opacity: 0.3
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 31.706,
  cy: 21.412,
  r: 2.882,
  fill: "#EF5D54"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#EF5D54",
  clipPath: "url(#ic-media_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.059,
  height: 23.059,
  x: 17.706,
  y: 47.187,
  opacity: 0.7,
  rx: 2.471,
  transform: "rotate(-45 17.706 47.187)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 26.337,
  height: 26.337,
  x: 3.294,
  y: 47.447,
  rx: 2.471,
  transform: "rotate(-45 3.294 47.447)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-media_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27.463,
  height: 21.578,
  x: 13.037,
  y: 24.246,
  fill: "#fff",
  rx: 2.471
})))));
export default SvgIcMedia;